import {useContext} from "react";
import {EntityContext} from "../../context/EntityContext";
import {ListContext} from "../../context/ListContext";


export const CardCounterGroup = () => {
    const {list, setList} = useContext(ListContext);
    const {setCurrentTag} = useContext(EntityContext);

    var counter = {
        "draft" : { name: 'Entwurf', total: 0,  monthOverMonthChange: 0, changeType: 'positive'  },
        "inTender" : { name: 'Angebote werden eingeholt', total: 0,  monthOverMonthChange: 0, changeType: 'positive'  },
        "contracted" : { name: 'Beauftragt', total: 0,  monthOverMonthChange: 0, changeType: 'positive'  },
        "inDevelopment" : { name: 'In Bearbeitung', total: 0,  monthOverMonthChange: 0, changeType: 'positive'  },
        "inReview" : { name: 'Zur Abnahme', total: 0,  monthOverMonthChange: 0, changeType: 'positive'  },
        "completed" : { name: 'Abgeschlossen', total: 0,  monthOverMonthChange: 0, changeType: 'positive'  }
    }

    const filterListByTag = (resetSearch) => {
        const newResultList = [];


        for (let a of  list) {
            if (resetSearch === a?.stage) {
                a.hidden = false;
                newResultList?.push(a);
            } else {
                a.hidden = true;
                newResultList?.push(a);
            }
        }

        setList(newResultList);
    };

    if(typeof list !== "undefined") {
        for (var a of list) {

            if(typeof counter?.[a?.stage] !== "undefined") {
                counter[a?.stage].total = counter?.[a?.stage]?.total + 1;
                const currentDate = new Date();
                const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
                const timestamp = firstDayOfMonth.getTime();

                if(timestamp < currentDate ) {
                    counter[a?.stage].monthOverMonthChange = counter?.[a?.stage]?.monthOverMonthChange + 1;
                }
            }
        }
    }



    return (
        <div className=" mx-7 mt-7 mb-14 ">
            <dl className="mx-auto grid grid-cols-2 gap-[1px] cursor-pointer rounded-lg bg-gray-300 border-gray-500 border sm:grid-cols-2 lg:grid-cols-6" style={{boxShadow: "0 0 30px 0 rgba(0,0,0,.03)"}}>
                {Object.keys(counter)?.map((stat) => (
                    <div key={counter?.[stat]?.name} onClick={() => {setCurrentTag(stat); filterListByTag(stat);}}  className="flex rounded-lg flex-wrap items-baseline justify-between bg-white gap-x-4 gap-y-2 px-4 py-5 sm:px-6 xl:px-8" >
                        <dt className="text-sm/6 font-medium truncate text-gray-900" title={counter?.[stat]?.name}>{counter?.[stat]?.name}</dt>
                        <dd className="w-full flex-none text-3xl/10 font-medium tracking-tight text-gray-900">{counter?.[stat]?.total}</dd>
                    </div>
                ))}
            </dl>
        </div>
    )
}
